export enum ContractMode {
	CREATE = 'CREATE_CONTRACT',
	VIEW = 'VIEW_CONTRACT',
	EDIT = 'EDIT_CONTRACT'
}